import { apiClient } from './api-client';

export interface Accessory {
  id: string;
  tenantId: string;
  name: string;
  description: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AccessoryListResponse {
  items: Accessory[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateAccessoryPayload {
  name: string;
  description?: string;
}

export type UpdateAccessoryPayload = Partial<CreateAccessoryPayload> & { isActive?: boolean };

export const accessoryService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
  }): Promise<AccessoryListResponse> =>
    apiClient.get<AccessoryListResponse>('/accessories', { params }).then((r) => r.data),

  listAll: (): Promise<Accessory[]> =>
    apiClient
      .get<AccessoryListResponse>('/accessories', { params: { pageSize: 100 } })
      .then((r) => r.data.items),

  create: (payload: CreateAccessoryPayload): Promise<Accessory> =>
    apiClient.post<Accessory>('/accessories', payload).then((r) => r.data),

  update: (id: string, payload: UpdateAccessoryPayload): Promise<Accessory> =>
    apiClient.patch<Accessory>(`/accessories/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/accessories/${id}`).then(() => undefined),
};
